module.exports = __webpack_public_path__ + "img/symbol_19_normal.0104babb.png";